module.exports = __webpack_public_path__ + "static/media/logo2.34d2acc0.svg";